export default __webpack_public_path__ + "static/media/record-button.7f21cc65.png";